
import { commonfunc } from '~/mixin/common'

export default {
  name: 'ProdPrice',
  mixins: [commonfunc],
  props: {
    price: {
      type: [Number, String],
      default: 0
    }
  }
}
